import { Trans } from '@lingui/macro'
import classNames from 'classnames'

import styles from './AccountMenu.module.scss'
import LogoutMenuItem from '../../account-page/menu/LogoutMenuItem'
import { useMenuItems } from '../../account-page/menu/useMenuItems'
import CloseIcon from '../../core/CloseIcon'
import NextIcon from '../../core/NextIcon'
import Link from '../../navigation/Link'
import paths from '../../paths'
import { DrawerContentProps } from '../../presentation/Drawer/Drawer'
import Heading from '../../typography/Heading'

export function AccountMenu({
    opened,
    close,
    logoutMenuItemClass,
    showHeading,
}: DrawerContentProps & {
    showHeading: boolean
    logoutMenuItemClass?: string
}) {
    const menuItems = useMenuItems()

    return (
        <div className={styles.container}>
            <nav>
                <ul>
                    {showHeading && (
                        <li className={styles.header}>
                            <Link
                                onClick={close}
                                name=""
                                exact
                                activeClassName={styles.active}
                                category=""
                                to="#"
                                className={classNames(
                                    styles.row,
                                    styles.menuItem,
                                )}
                            >
                                <Heading variant="h4" element="h4">
                                    <Trans id="account.menu.header">
                                        My Account
                                    </Trans>
                                </Heading>
                                <CloseIcon className={styles.closeIcon} />
                            </Link>
                        </li>
                    )}

                    {menuItems.map((item) => (
                        <li key={item.name}>
                            <Link
                                onClick={close}
                                name=""
                                exact
                                activeClassName={styles.active}
                                category=""
                                to={item.href}
                                className={classNames(
                                    styles.row,
                                    styles.menuItem,
                                )}
                            >
                                <span className={styles.icon}>{item.icon}</span>
                                <span className={styles.label}>
                                    {item.label}
                                </span>

                                <span className={styles.caret}>
                                    {item.badge && (
                                        <span className={styles.itemBadge}>
                                            {item.badge}
                                        </span>
                                    )}
                                    <NextIcon />
                                </span>
                            </Link>
                        </li>
                    ))}

                    <li className={logoutMenuItemClass ?? ''}>
                        <LogoutMenuItem
                            className={styles.logoutItem}
                            baseUrl={paths.account}
                            onClick={close}
                        />
                    </li>
                </ul>
            </nav>
        </div>
    )
}
